<template>
  <div class="page" :style="{ height: pageHeight - 50 + 'px' }">
    <img class="top" src="./assets/img/bg.png" alt="" />
    <div class="info">
      <div class="user">
        <div class="avator">
          <img :src="userInfo.img_path" alt="" />
        </div>
        <div class="name">
          {{ userInfo.nickname }}
        </div>
      </div>
      <div class="info-list">
        <div class="item">
          <div class="price">{{ mainData["sum(totalPrice)"] || 0 }}</div>
          <div class="name">定单金额</div>
        </div>
        <div class="item">
          <div class="price">{{ mainData["sum(needPay)"] || 0 }}</div>
          <div class="name">应付金额</div>
        </div>
        <div class="item">
          <div class="price">{{ mainData["sum(paid)"] || 0 }}</div>
          <div class="name">已付金额</div>
        </div>
        <div class="item" style="margin-top: 0.36rem">
          <div class="price">{{ mainData["count(id)"] || 0 }}</div>
          <div class="name">下单数</div>
        </div>
        <div class="item" style="margin-top: 0.36rem">
          <div class="price">
            {{ (mainData["sum(needPay)"] || mainData["sum(paid)"])? (mainData["sum(needPay)"] - mainData["sum(paid)"]):0 }}
          </div>
          <div class="name">尾款</div>
        </div>
        <div class="item" style="margin-top: 0.36rem">
          <div class="price">{{ mainData["sum(refund)"] || 0 }}</div>
          <div class="name">退款金额</div>
        </div>
      </div>
    </div>
    <div class="bar"></div>
    <div class="btns">
      <div class="title">我的功能</div>
      <div class="btn-list">
        <div class="btn-item" @click="gotoItem(1)">
          <div class="left">
            <img src="./assets/img/1.png" alt="" />
            <span>我的订单</span>
          </div>
          <div class="right">
            <van-icon color="#999999" name="arrow" />
          </div>
        </div>
        <div class="btn-item" @click="gotoItem(3)">
          <div class="left">
            <img src="./assets/img/4.png" alt="" />
            <span>付尾款</span>
          </div>
          <div class="right">
            <van-icon color="#999999" name="arrow" />
          </div>
        </div>
        <div class="btn-item" @click="gotoItem(2)">
          <div class="left">
            <img src="./assets/img/2.png" alt="" />
            <span>线路统计</span>
          </div>
          <div class="right">
            <van-icon color="#999999" name="arrow" />
          </div>
        </div>
        <!-- <div class="btn-item" @click="gotoItem(3)">
          <div class="left">
            <img src="./assets/img/3.png" alt="">
            <span>排期统计</span>
          </div>
          <div class="right">
            <van-icon color="#999999" name="arrow" />
          </div>
        </div> -->
      </div>
    </div>

    <div class="logout">
      <div class="btn" @click="logOut()">退出登录</div>
    </div>
  </div>
</template>

<script>
import appService from "@/services/request/appService";
import BindMobile from "@/pages/common/BindMobile";
import wechatService from "@/services/request/wechatService";
import store from "store";
import { Dialog } from "vant";
export default {
  name: "PersonalIndex",
  components: {
    BindMobile,
    Dialog,
  },
  data() {
    return {
      mine: {},
      pageHeight: window.innerHeight,
      showBind: false,
      mainData: {},
      userInfo: {},
    };
  },
  created() {
    console.log(!store.get("loginData") || !store.get("loginData").id)
    if (!store.get("loginData") || !store.get("loginData").id) {
      // alert(666)
      this.$router.replace({
        name: "Login",
        query: {
          iid: this.$route.query.iid ? this.$route.query.iid : this.mine.iid,
        },
      });
    } else {
      if (store.get("loginData").op == 1 || store.get("loginData").op == 2) {
        //管理员
        this.$router.replace({
          name: "BigDataIndex",
          query: {
            iid: store.get("loginData").interest_id,
            noTab: 1,
          },
        });
        return;
      }
    }

    document.title = "我的";
    this.mine = store.get("mine") || {};
    this.loadUserInfo();
    this.loadList();
  },
  mounted: function () {
    this.$nextTick(function () {
      
    });
  },
  methods: {
    logOut() {
      Dialog.confirm({
        title: "提示",
        message: "确定退出登录吗?",
      })
        .then(() => {
          // on confirm
          localStorage.clear();
          this.$router.replace({
            name: "Login",
            query: {
              iid: this.$route.query.iid
                ? this.$route.query.iid
                : this.mine.iid,
            },
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    loadUserInfo() {
      // appService
      //   .getUserInfo({
      //     userid: this.mine.unionId,
      //     openid: this.mine.openId,
      //     iid: this.$route.query.iid,
      //   })
      //   .then(data => {
      //     this.userInfo = data
      //   })
      this.userInfo = store.get("loginData");
    },
    loadList() {
      appService
        .getMineData({
          startTime: "",
          endTime: "",
          rid: this.userInfo.id,
          iid: this.$route.query.iid,
        })
        .then((data) => {
          console.log("data", data);
          if (!data.code) {
            this.mainData = data[0];
          } else {
            this.$toast.fail(data.msg);
          }
        });
    },
    gotoItem(type) {
      if (type == 1) {
        this.$router.push({
          name: "BigDataList",
          query: {
            index: 1,
            iid: this.$route.query.iid,
          },
        });
      }
      if (type == 2) {
        this.$router.push({
          path: "/m/bigactdata/list",
          query: {
            index: 2,
            iid: this.$route.query.iid,
          },
        });
      }
      if(type == 3){
        this.$router.push({
          name: "PersonalOrder",
          query: {
            iid: this.$route.query.iid,
          },
        });
      }
    },
    setBindVisible(show, bindOk) {
      this.showBind = show;
      console.log("show:" + show + "||" + "bindOk:" + bindOk);
    },
  },
};
</script>

<style scoped lang="less">
.page {
  font-size: 0.28rem;
  background: #fff;
  min-height: 100%;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  .top {
    width: 100%;
    height: 3.59rem;
  }
  .info {
    width: 100%;
    background: #fff;
    padding: 0.4rem 0;
    box-sizing: border-box;
    .user {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-top: -1.2rem;
      .avator {
        width: 1.41rem;
        height: 1.41rem;
        box-shadow: 0rem 0.04rem 0.13rem 0.04rem rgba(0, 0, 0, 0.09);
        border-radius: 50%;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .name {
        margin-top: 0.16rem;
        font-size: 0.32rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
      }
    }
    .info-list {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      margin-top: 0.43rem;
      .item {
        width: 33.3%;
        flex-shrink: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .price {
          font-size: 0.36rem;
          font-family: DINAlternate-Bold, DINAlternate;
          font-weight: bold;
          color: #333333;
        }
        .name {
          font-size: 0.22rem;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #babfc2;
          margin-top: 0.05rem;
        }
      }
    }
  }
  .bar {
    width: 100%;
    height: 0.11rem;
    background: #f0f2f5;
  }
  .btns {
    padding: 0.4rem;
    background: #fff;
    .title {
      font-size: 0.29rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
    }
    .btn-list {
      .btn-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0.27rem 0;
        .left {
          display: flex;
          align-items: center;
          img {
            width: 0.34rem;
            height: 0.38rem;
          }
          span {
            font-size: 0.29rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            margin-left: 0.22rem;
          }
        }
        .right {
        }
      }
    }
  }
  .logout {
    width: 100%;
    padding: 0.4rem;
    background: #fff;
    padding-top: 0;
    .btn {
      height: 0.9rem;
      border: 1px solid rgb(9, 187, 7);
      border-radius: 4px;
      font-size: 0.26rem;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgb(9, 187, 7);
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>

